import script from "./fill-in-apply-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./fill-in-apply-info.vue?vue&type=script&setup=true&lang=ts"

import "./fill-in-apply-info.vue?vue&type=style&index=0&id=97b3a986&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b3a986"]])

export default __exports__